"use client"
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

interface Props {
    label: string,
    value: any,
    onChange: (date: Dayjs | null) => void ,
    conditional?: boolean
}
const today = dayjs();

export const InputDate = ({ label, value, onChange, conditional = false }: Props) => (

    

    <DatePicker
        label={label}
        value={dayjs(value)}
        format="DD/MM/YYYY"
        onChange={(date) => onChange(date)}
        className="w-full bg-white"
        maxDate={conditional ? today : null}
    />
);